var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isFiltered)?_c('div',[_c('Tabs',{attrs:{"tab-items":_vm.tabItems,"isTable":""}})],1):_c('div',{staticClass:"container"},[_c('InfoBox',{attrs:{"message":"Select CUC code and Revision to view Additional Information"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }